// This file is auto-generated by @hey-api/openapi-ts

export const $EmailTemplateView = {
    required: ['template_name'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        template_name: {
            title: 'Template name',
            type: 'string',
            maxLength: 64,
            minLength: 1
        },
        template_info: {
            title: 'Template info',
            type: 'object'
        }
    }
} as const;

export const $MFACodeResendRequest = {
    required: ['user_id'],
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $MFACodeVerifyRequest = {
    required: ['code', 'user_id'],
    type: 'object',
    properties: {
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $MFACodeRequest = {
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        }
    }
} as const;

export const $MFACodeResponse = {
    required: ['code_id'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TextTemplateView = {
    required: ['template_name', 'template'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        template_name: {
            title: 'Template name',
            type: 'string',
            maxLength: 64,
            minLength: 1
        },
        template: {
            title: 'Template',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $UserSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $UserInternalSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $AccountOpsAccountMergeRequest = {
    required: ['surviving_account_workspace_id', 'surviving_account_workspace_type', 'target_account_workspace_id'],
    type: 'object',
    properties: {
        surviving_account_workspace_id: {
            title: 'Surviving account workspace id',
            type: 'string',
            format: 'uuid'
        },
        surviving_account_workspace_type: {
            title: 'Surviving account workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        target_account_workspace_id: {
            title: 'Target account workspace id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $AccountOpsAccountMergeResponse = {
    required: ['merged_print_card_requests', 'updated_print_card_requests_count'],
    type: 'object',
    properties: {
        merged_print_card_requests: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        updated_print_card_requests_count: {
            title: 'Updated print card requests count',
            type: 'integer'
        }
    }
} as const;

export const $AccountOpsDataRetentionClearRequest = {
    required: ['workspace_id_list'],
    type: 'object',
    properties: {
        workspace_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $AccountOpsDataRetentionClearResponse = {
    required: ['workspace_id', 'data_retention_clear_completed'],
    type: 'object',
    properties: {
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        data_retention_clear_completed: {
            title: 'Data retention clear completed',
            type: 'boolean'
        }
    }
} as const;

export const $AccountOpsDataRetentionUpdateRequest = {
    required: ['user_id_data_retention_status_list'],
    type: 'object',
    properties: {
        user_id_data_retention_status_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/UserDataRetentionStatus'
            }
        }
    }
} as const;

export const $AccountOpsDataRetentionUpdateResponse = {
    required: ['updated_users', 'errors'],
    type: 'object',
    properties: {
        updated_users: {
            type: 'array',
            items: {
                '$ref': '#/definitions/AccountOpsDataRetentionUserAccountView'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/definitions/UserDataRetentionStatus'
            }
        }
    }
} as const;

export const $AccountOpsMarketingStatusUpdateRequest = {
    required: ['order_id_marketing_status_list'],
    type: 'object',
    properties: {
        order_id_marketing_status_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderMarketingStatus'
            }
        }
    }
} as const;

export const $AccountOpsMarketingStatusUpdateResponse = {
    required: ['updated_orders', 'errors'],
    type: 'object',
    properties: {
        updated_orders: {
            type: 'array',
            items: {
                '$ref': '#/definitions/AccountOpsMarketingOrderView'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderMarketingStatus'
            }
        }
    }
} as const;

export const $ApiUserLogin = {
    required: ['api_id', 'api_secret'],
    type: 'object',
    properties: {
        api_id: {
            title: 'Api id',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        api_secret: {
            title: 'Api secret',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $ApiUserLoginResponse = {
    required: ['access_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $ExternalServiceUserAccountView = {
    required: ['id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $ExternalServiceUserRegistration = {
    required: ['username', 'first_name', 'last_name', 'display_name', 'user_metadata'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        }
    }
} as const;

export const $GuestUserLoginResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserWorkspaceLogin = {
    required: ['username', 'password', 'access_token'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestMFAUserWorkspaceLoginComplete = {
    required: ['code_id', 'code', 'password', 'refresh_token'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        },
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestMFAUserWorkspaceLoginCompleteResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $UserLogin = {
    required: ['username', 'password'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $UserLoginResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $MFAUserLoginComplete = {
    required: ['code_id', 'code', 'password'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        },
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $MFAUserLoginCompleteResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $MFAUserLoginSendCode = {
    required: ['method'],
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        }
    }
} as const;

export const $MFAUserLoginSendCodeResponse = {
    required: ['code_id'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $MFAUserLoginStart = {
    required: ['username', 'password'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $MFAUserLoginStartResponse = {
    required: ['login_token'],
    type: 'object',
    properties: {
        login_token: {
            title: 'Login token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $MFAUserLoginResend = {
    required: ['method'],
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        }
    }
} as const;

export const $PolicyView = {
    type: 'object',
    properties: {
        version_id: {
            title: 'Version id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        version: {
            title: 'Version',
            type: 'string',
            maxLength: 20,
            minLength: 1,
            'x-nullable': true
        },
        storage_type: {
            title: 'Storage type',
            type: 'string',
            enum: ['gcloud']
        },
        storage_location: {
            title: 'Storage location',
            type: 'object'
        }
    }
} as const;

export const $PolicyAgreement = {
    required: ['policy_version_id'],
    type: 'object',
    properties: {
        policy_version_id: {
            title: 'Policy version id',
            type: 'string',
            format: 'uuid'
        },
        device_type: {
            title: 'Device type',
            type: 'string',
            maxLength: 256,
            minLength: 1
        },
        device_info: {
            '$ref': '#/definitions/DeviceInfo'
        }
    }
} as const;

export const $PolicyUpload = {
    required: ['name'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        version: {
            title: 'Version',
            type: 'string',
            maxLength: 20,
            minLength: 1
        }
    }
} as const;

export const $PolicyAccessResponse = {
    required: ['uri', 'policy_version_id'],
    type: 'object',
    properties: {
        uri: {
            title: 'Uri',
            type: 'string',
            maxLength: 1024,
            minLength: 1
        },
        policy_version_id: {
            title: 'Policy version id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $ServiceUserAccountViewResponse = {
    required: ['id', 'active', 'created', 'updated', 'username', 'first_name', 'last_name', 'email', 'email_verified', 'phone_number', 'phone_verified', 'date_joined', 'display_name', 'user_metadata', 'user_metadata_private', 'system_metadata', 'mfa_login_required', 'user_type', 'adult_user', 'data_retention_status', 'marketing_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        updated: {
            title: 'Updated',
            type: 'string',
            format: 'date-time'
        },
        username: {
            title: 'Username',
            type: 'string',
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            minLength: 1
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            minLength: 1
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        system_metadata: {
            title: 'System metadata',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        data_retention_status: {
            title: 'Data retention status',
            type: 'string',
            enum: ['not_run', 'policy_check', 'completed']
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $ChildUserRegistration = {
    required: ['username', 'password', 'first_name', 'last_name', 'adult_user'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        }
    }
} as const;

export const $ChildUserRegistrationResponse = {
    required: ['id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $OrganizationTokenRefreshResponse = {
    required: ['access_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $TokenRefreshResponse = {
    required: ['access_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $UserWorkspacePublicProfileRequestView = {
    required: ['workspace_ids'],
    type: 'object',
    properties: {
        workspace_ids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $UserWorkspacePublicProfileResponseView = {
    required: ['id', 'first_name', 'last_name', 'display_name', 'user_metadata', 'workspace_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryBulkRequestView = {
    required: ['user_pii_data_entry_workspace_id_and_id_list'],
    type: 'object',
    properties: {
        user_pii_data_entry_workspace_id_and_id_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/UserWorkspaceIDWorkspacePIIDataPair'
            }
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryView = {
    required: ['id', 'created', 'active', 'user_id', 'pii_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryBulkView = {
    required: ['user_workspace_pii_data_entries'],
    type: 'object',
    properties: {
        user_workspace_pii_data_entries: {
            type: 'array',
            items: {
                '$ref': '#/definitions/UserWorkspacePIIDataEntryView'
            }
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryFileCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserWorkspacePIIDataEntryUpdateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserAccountView = {
    required: ['id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $ConfirmEmailVerification = {
    required: ['signature'],
    type: 'object',
    properties: {
        signature: {
            title: 'Signature',
            type: 'string',
            maxLength: 150,
            minLength: 1
        }
    }
} as const;

export const $EmailVerificationRequest = {
    type: 'object',
    properties: {}
} as const;

export const $GuestUserRegistration = {
    required: ['adult_user'],
    type: 'object',
    properties: {
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        }
    }
} as const;

export const $GuestUserRegistrationResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserRegistrationComplete = {
    required: ['username', 'password'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        parent_email: {
            title: 'Parent email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $ConfirmResetPassword = {
    required: ['password', 'signature'],
    type: 'object',
    properties: {
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        signature: {
            title: 'Signature',
            type: 'string',
            maxLength: 150,
            minLength: 1
        }
    }
} as const;

export const $ResetPassword = {
    required: ['username'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $ResetPasswordResponse = {
    required: ['detail'],
    type: 'object',
    properties: {
        detail: {
            title: 'Detail',
            type: 'string',
            maxLength: 150,
            minLength: 1
        }
    }
} as const;

export const $UserAccountPublicProfileRequestView = {
    required: ['user_ids'],
    type: 'object',
    properties: {
        user_ids: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $UserAccountPublicProfileResponseView = {
    required: ['id', 'first_name', 'last_name', 'display_name', 'user_metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        }
    }
} as const;

export const $UserRegistration = {
    required: ['username', 'email', 'password', 'first_name', 'last_name', 'adult_user'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        }
    }
} as const;

export const $UserRegistrationResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $UserRegistrationUsernameAvailable = {
    required: ['username'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $PhoneNumberVerificationResendRequest = {
    required: ['user_id'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $PhoneNumberVerificationVerifyRequest = {
    required: ['code', 'user_id'],
    type: 'object',
    properties: {
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $ChangeEmail = {
    required: ['password', 'email'],
    type: 'object',
    properties: {
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $GuestUserChangeEmail = {
    required: ['email'],
    type: 'object',
    properties: {
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $ChangePassword = {
    required: ['old_password', 'new_password'],
    type: 'object',
    properties: {
        old_password: {
            title: 'Old password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        new_password: {
            title: 'New password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $UserPIIDataEntryView = {
    required: ['id', 'created', 'active', 'user_id', 'pii_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserPIIDataEntryCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserPIIDataEntryFileCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $UserPIIDataEntryUpdateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $PhoneNumberVerificationRequest = {
    type: 'object',
    properties: {}
} as const;

export const $UserDataRetentionStatus = {
    required: ['user_id', 'data_retention_status'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        data_retention_status: {
            title: 'Data retention status',
            type: 'string',
            enum: ['not_run', 'policy_check', 'completed']
        }
    }
} as const;

export const $AccountOpsDataRetentionUserAccountView = {
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated: {
            title: 'Updated',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        first_name: {
            title: 'First Name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last Name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display Name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        system_metadata: {
            title: 'System metadata',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        data_retention_status: {
            title: 'Data retention status',
            type: 'string',
            enum: ['not_run', 'policy_check', 'completed']
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $UserMarketingStatus = {
    required: ['user_id', 'marketing_status'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $AccountOpsMarketingUserAccountView = {
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        updated: {
            title: 'Updated',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        first_name: {
            title: 'First Name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last Name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        },
        date_joined: {
            title: 'Date joined',
            type: 'string',
            format: 'date-time'
        },
        display_name: {
            title: 'Display Name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        user_metadata_private: {
            title: 'User metadata private',
            type: 'object'
        },
        system_metadata: {
            title: 'System metadata',
            type: 'object'
        },
        mfa_login_required: {
            title: 'Mfa login required',
            type: 'boolean'
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'external_service', 'api', 'guest']
        },
        adult_user: {
            title: 'Adult user',
            type: 'boolean'
        },
        data_retention_status: {
            title: 'Data retention status',
            type: 'string',
            enum: ['not_run', 'policy_check', 'completed']
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $DeviceInfo = {
    required: ['info'],
    type: 'object',
    properties: {
        info_type: {
            title: 'Info type',
            type: 'string',
            enum: ['finterprint_pro', 'other']
        },
        info: {
            title: 'Info',
            type: 'object'
        }
    }
} as const;

export const $UserWorkspaceIDWorkspacePIIDataPair = {
    required: ['workspace_id', 'user_pii_data_entry_id'],
    type: 'object',
    properties: {
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        user_pii_data_entry_id: {
            title: 'User pii data entry id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $AccountOpsMemberOrganizationWorkspaceListView = {
    required: ['user_id_list'],
    type: 'object',
    properties: {
        user_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $AccountOpsMemberOrganizationWorkspaceListResponseView = {
    required: ['user_id', 'workspace_list'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        workspace_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/AccountOpsMemberOrganizationWorkspaceObjectView'
            }
        }
    }
} as const;

export const $GuestFamilyRegistrationCreate = {
    required: ['member_user_id'],
    type: 'object',
    properties: {
        member_user_id: {
            title: 'Member user id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $GuestFamilyRegistrationCreateResponse = {
    required: ['id', 'created', 'active', 'owner', 'organization_type', 'name', 'brand_data', 'description', 'member_id', 'member_role'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        },
        member_id: {
            title: 'Member id',
            type: 'string',
            format: 'uuid'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        }
    }
} as const;

export const $GuestFamilyRegistrationComplete = {
    required: ['last_name', 'parent_email_address', 'guest_user_id'],
    type: 'object',
    properties: {
        last_name: {
            title: 'Last name',
            type: 'string'
        },
        parent_email_address: {
            title: 'Parent email address',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        guest_user_id: {
            title: 'Guest user id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $GuestFamilyRegistrationCompleteResponse = {
    required: ['id', 'created', 'active', 'owner', 'organization_type', 'name', 'brand_data', 'description', 'member_id', 'member_role'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        },
        member_id: {
            title: 'Member id',
            type: 'string',
            format: 'uuid'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        }
    }
} as const;

export const $OrganizationInviteAccept = {
    required: ['signature'],
    type: 'object',
    properties: {
        signature: {
            title: 'Signature',
            type: 'string',
            maxLength: 150,
            minLength: 1
        }
    }
} as const;

export const $OrganizationInviteView = {
    required: ['organization', 'inviting_user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        organization: {
            title: 'Organization',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        inviting_user_id: {
            title: 'Inviting user id',
            type: 'string',
            format: 'uuid'
        },
        expiration: {
            title: 'Expiration',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        accepted: {
            title: 'Accepted',
            type: 'boolean'
        },
        accepted_data: {
            title: 'Accepted data',
            type: 'object'
        }
    }
} as const;

export const $MemberOrganizationWorkspaceListView = {
    required: ['user_id_list'],
    type: 'object',
    properties: {
        user_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $MemberOrganizationWorkspaceListResponseView = {
    required: ['user_id', 'workspace_list'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        workspace_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/MemberOrganizationWorkspaceObjectView'
            }
        }
    }
} as const;

export const $MemberOrganizationView = {
    required: ['id', 'created', 'active', 'owner', 'organization_type', 'name', 'brand_data', 'description', 'tags', 'member_role'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['owner', 'admin', 'member']
        }
    }
} as const;

export const $OrganizationView = {
    required: ['organization_type'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        num_members: {
            title: 'Num members',
            type: 'integer',
            readOnly: true,
            default: 0
        },
        tags: {
            type: 'array',
            items: {
                title: 'Tags',
                type: 'string',
                enum: ['demo', 'client']
            }
        }
    }
} as const;

export const $OrganizationCreate = {
    required: ['owner_id', 'name', 'brand_data', 'description', 'organization_type'],
    type: 'object',
    properties: {
        owner_id: {
            title: 'Owner id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['family', 'other']
        }
    }
} as const;

export const $OrganizationCreateResponse = {
    required: ['id', 'created', 'active', 'owner', 'organization_type', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        }
    }
} as const;

export const $OrganizationMemberView = {
    required: ['organization', 'user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        organization: {
            title: 'Organization',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['admin', 'member']
        },
        member_access_rights: {
            title: 'Member access rights',
            type: 'object'
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryBulkRequestView = {
    required: ['organization_pii_data_entry_workspace_id_and_id_list'],
    type: 'object',
    properties: {
        organization_pii_data_entry_workspace_id_and_id_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrganizationWorkspaceIDWorkspacePIIDataPair'
            }
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryView = {
    required: ['id', 'created', 'active', 'organization_id', 'pii_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryBulkView = {
    required: ['organization_workspace_pii_data_entries'],
    type: 'object',
    properties: {
        organization_workspace_pii_data_entries: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrganizationWorkspacePIIDataEntryView'
            }
        }
    }
} as const;

export const $OrganizationWorkspaceProfileRequest = {
    required: ['workspace_id_list'],
    type: 'object',
    properties: {
        workspace_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $OrganizationWorkspaceProfileResponse = {
    required: ['id', 'name', 'brand_data', 'description', 'organization_type', 'workspace_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryFileCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationWorkspacePIIDataEntryUpdateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationProfileRequest = {
    required: ['organization_id_list'],
    type: 'object',
    properties: {
        organization_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $OrganizationProfileResponse = {
    required: ['id', 'name', 'brand_data', 'description', 'organization_type'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        }
    }
} as const;

export const $OrganizationInviteCreate = {
    type: 'object',
    properties: {
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $OrganizationInviteCreateResponse = {
    required: ['organization', 'inviting_user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        organization: {
            title: 'Organization',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        inviting_user_id: {
            title: 'Inviting user id',
            type: 'string',
            format: 'uuid'
        },
        expiration: {
            title: 'Expiration',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        accepted: {
            title: 'Accepted',
            type: 'boolean'
        },
        accepted_data: {
            title: 'Accepted data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationMemberPublicProfileView = {
    required: ['user_id', 'first_name', 'last_name', 'display_name', 'user_metadata', 'member_role', 'active'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $OrganizationMemberChildCreate = {
    required: ['username', 'email', 'password', 'first_name', 'last_name'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $OrganizationMemberViewResponse = {
    required: ['id', 'active', 'created', 'user_metadata', 'member_role', 'member_access_rights', 'organization_id', 'user_id', 'first_name', 'last_name', 'display_name'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        },
        member_access_rights: {
            title: 'Member access rights',
            type: 'object'
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        }
    }
} as const;

export const $OrganizationMemberChangeRole = {
    required: ['member_role'],
    type: 'object',
    properties: {
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['admin', 'member']
        }
    }
} as const;

export const $OrganizationMemberRoleView = {
    required: ['member_role'],
    type: 'object',
    properties: {
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 50,
            minLength: 1
        }
    }
} as const;

export const $OrganizationPIIDataEntryView = {
    required: ['id', 'created', 'active', 'organization_id', 'pii_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationPIIDataEntryCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationPIIDataEntryFileCreateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationPIIDataEntryUpdateView = {
    required: ['pii_data'],
    type: 'object',
    properties: {
        pii_data: {
            title: 'Pii data',
            type: 'object'
        }
    }
} as const;

export const $OrganizationSetOwner = {
    required: ['owner'],
    type: 'object',
    properties: {
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $OrganizationSetParameterResponse = {
    required: ['id', 'created', 'active', 'owner', 'organization_type', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        }
    }
} as const;

export const $OrganizationSetTags = {
    required: ['tags'],
    type: 'object',
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        }
    }
} as const;

export const $OrganizationInternalSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $OrganizationSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $AccountOpsMemberOrganizationWorkspaceObjectView = {
    required: ['name', 'owner', 'organization_id', 'organization_type', 'workspace_id_list'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        organization_type: {
            title: 'Organization type',
            type: 'string',
            enum: ['guest_family', 'family', 'other']
        },
        workspace_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $MemberOrganizationWorkspaceObjectView = {
    required: ['name', 'organization_id', 'brand_data', 'description', 'tags', 'workspace_id_list'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['demo', 'client']
            },
            maxItems: 2
        },
        workspace_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $OrganizationWorkspaceIDWorkspacePIIDataPair = {
    required: ['workspace_id', 'organization_pii_data_entry_id'],
    type: 'object',
    properties: {
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        organization_pii_data_entry_id: {
            title: 'Organization pii data entry id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $ApiUserStatusResponse = {
    required: ['id', 'created', 'active', 'user_id', 'organization_id', 'user_metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        }
    }
} as const;

export const $OrganizationApiUserView = {
    required: ['id', 'created', 'active', 'user_id', 'organization_id', 'api_id', 'api_secret', 'user_metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        organization_id: {
            title: 'Organization id',
            type: 'string',
            format: 'uuid'
        },
        api_id: {
            title: 'Api id',
            type: 'string',
            minLength: 1
        },
        api_secret: {
            title: 'Api secret',
            type: 'string',
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        }
    }
} as const;

export const $OrganizationApiUserCreate = {
    required: ['name'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardView = {
    required: ['id', 'created', 'active', 'workspace_type', 'workspace_id', 'card_processing_status', 'card_set_id', 'card_set_name', 'card_set_template', 'card_variant_base', 'card_variant_attributes', 'card_creation_step_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoResponseSerializers'
        },
        card_processing_status: {
            title: 'Card processing status',
            type: 'string',
            enum: ['not_started', 'submitted', 'generating', 'completed', 'finalized', 'failed', 'deleted', 'variant_locked', 'variant_submitted', 'variant_generating']
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsResponse'
        },
        card_preview: {
            '$ref': '#/definitions/CardPreviewView'
        },
        card_creation_step_status: {
            title: 'Card creation step status',
            type: 'object'
        }
    }
} as const;

export const $CardPackResponse = {
    required: ['id', 'name', 'priority', 'card_pack_metadata', 'card_set_set_template_variant_bases', 'card_pack_variant_attributes', 'active'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        card_pack_metadata: {
            title: 'Card pack metadata',
            type: 'object'
        },
        card_set_set_template_variant_bases: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardPackCardSetSetTemplateVariantBaseResponse'
            }
        },
        card_pack_variant_attributes: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardPackVariantAttributeResponse'
            }
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $CardPackCreate = {
    required: ['name', 'priority', 'card_pack_metadata'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        card_pack_metadata: {
            title: 'Card pack metadata',
            type: 'object'
        },
        card_pack_variant_attributes: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardPackVariantAttributeCreate'
            }
        },
        card_set_set_template_variant_bases: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardPackCardSetSetTemplateVariantBaseCreate'
            }
        }
    }
} as const;

export const $CardSetResponse = {
    required: ['id', 'name', 'priority', 'active', 'card_set_metadata', 'card_set_template_variant_bases', 'card_variant_attributes'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        card_set_metadata: {
            title: 'Card set metadata',
            type: 'object'
        },
        card_set_template_variant_bases: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardSetTemplateVariantBaseResponse'
            }
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardSetVariantAttributeResponse'
            }
        }
    }
} as const;

export const $CardSetCreate = {
    required: ['name', 'priority', 'card_set_metadata', 'card_set_template_variant_bases'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        card_set_metadata: {
            title: 'Card set metadata',
            type: 'object'
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardSetVariantAttributeCreate'
            }
        },
        card_set_template_variant_bases: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardSetTemplateVariantBaseCreate'
            }
        }
    }
} as const;

export const $CardSetPackResponse = {
    required: ['id', 'active', 'card_set_id', 'card_pack_id', 'card_set_pack_type', 'card_set_pack_metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        card_set_pack_type: {
            title: 'Card set pack type',
            type: 'string',
            enum: ['order', 'marketing']
        },
        card_set_pack_metadata: {
            title: 'Card set pack metadata',
            type: 'object'
        }
    }
} as const;

export const $CardSetPackCreate = {
    required: ['card_set_id', 'card_pack_id', 'card_set_pack_type', 'card_set_pack_metadata'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        card_set_pack_type: {
            title: 'Card set pack type',
            type: 'string',
            enum: ['order', 'marketing']
        },
        card_set_pack_metadata: {
            title: 'Card set pack metadata',
            type: 'object'
        }
    }
} as const;

export const $CardSetValidateBuild = {
    required: ['card_set_template', 'card_variant_base', 'card_variant_attributes'],
    type: 'object',
    properties: {
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        }
    }
} as const;

export const $CardVariantAttributeView = {
    required: ['card_variant_attribute', 'card_variant_attribute_asset_data'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_variant_attribute_asset_data: {
            title: 'Card variant attribute asset data',
            type: 'object'
        }
    }
} as const;

export const $CardVariantAttributeIconCreate = {
    required: ['card_variant_attribute'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        }
    }
} as const;

export const $CardVariantAttributeCreate = {
    required: ['card_variant_attribute', 'card_variant_attribute_asset_data'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_variant_attribute_asset_data: {
            title: 'Card variant attribute asset data',
            type: 'object'
        }
    }
} as const;

export const $ServiceCardsDownloadRequest = {
    required: ['card_id_list'],
    type: 'object',
    properties: {
        card_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $ServiceCardsDownloadView = {
    required: ['cards', 'errors'],
    type: 'object',
    properties: {
        cards: {
            type: 'array',
            items: {
                '$ref': '#/definitions/ServiceCardsDownloadCardView'
            }
        },
        errors: {
            type: 'array',
            items: {
                '$ref': '#/definitions/ServiceCardsDownloadCardErrorView'
            }
        }
    }
} as const;

export const $CardUploadCreateView = {
    required: ['workspace_type', 'workspace_id', 'athlete_info', 'card_set_name', 'card_set_template', 'card_variant_base', 'card_variant_attributes', 'photo_file_tag', 'front_preview_file_tag', 'back_preview_file_tag', 'card_tarball_file_tag'],
    type: 'object',
    properties: {
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_info: {
            '$ref': '#/definitions/CardUploadAthleteInfoView'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        photo_file_tag: {
            title: 'Photo file tag',
            type: 'string',
            minLength: 1
        },
        front_preview_file_tag: {
            title: 'Front preview file tag',
            type: 'string',
            minLength: 1
        },
        back_preview_file_tag: {
            title: 'Back preview file tag',
            type: 'string',
            minLength: 1
        },
        card_tarball_file_tag: {
            title: 'Card tarball file tag',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardOpView = {
    required: ['id', 'created', 'active', 'workspace_type', 'workspace_id', 'card_processing_status', 'card_set_id', 'card_set_name', 'card_set_template', 'card_variant_base', 'card_variant_attributes'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoResponseSerializers'
        },
        card_processing_status: {
            title: 'Card processing status',
            type: 'string',
            enum: ['not_started', 'submitted', 'generating', 'completed', 'finalized', 'failed', 'deleted', 'variant_locked', 'variant_submitted', 'variant_generating']
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsResponse'
        }
    }
} as const;

export const $MarketingCampaignCardPackResponse = {
    required: ['id', 'card_pack', 'quantity'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        card_pack: {
            '$ref': '#/definitions/CardPackResponse'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        }
    }
} as const;

export const $MarketingCampaignResponse = {
    required: ['id', 'created', 'active', 'start_time', 'end_time', 'current_redemptions', 'max_redemptions', 'max_redemptions_per_workspace', 'max_redemptions_per_user', 'max_redemptions_per_email', 'guest_allowed', 'system_metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        start_time: {
            title: 'Start time',
            type: 'string',
            format: 'date-time'
        },
        end_time: {
            title: 'End time',
            type: 'string',
            format: 'date-time'
        },
        current_redemptions: {
            title: 'Current redemptions',
            type: 'integer'
        },
        max_redemptions: {
            title: 'Max redemptions',
            type: 'integer'
        },
        max_redemptions_per_workspace: {
            title: 'Max redemptions per workspace',
            type: 'integer'
        },
        max_redemptions_per_user: {
            title: 'Max redemptions per user',
            type: 'integer'
        },
        max_redemptions_per_email: {
            title: 'Max redemptions per email',
            type: 'integer'
        },
        guest_allowed: {
            title: 'Guest allowed',
            type: 'boolean'
        },
        card_packs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/MarketingCampaignCardPackResponse'
            }
        },
        system_metadata: {
            title: 'System metadata',
            type: 'object'
        }
    }
} as const;

export const $MarketingCampaignCreate = {
    required: ['name', 'start_time', 'end_time', 'max_redemptions', 'max_redemptions_per_workspace', 'max_redemptions_per_user', 'max_redemptions_per_email', 'guest_allowed'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        start_time: {
            title: 'Start time',
            type: 'string',
            format: 'date-time'
        },
        end_time: {
            title: 'End time',
            type: 'string',
            format: 'date-time'
        },
        max_redemptions: {
            title: 'Max redemptions',
            type: 'integer',
            minimum: 1
        },
        max_redemptions_per_workspace: {
            title: 'Max redemptions per workspace',
            type: 'integer',
            minimum: 1
        },
        max_redemptions_per_user: {
            title: 'Max redemptions per user',
            type: 'integer',
            minimum: 1
        },
        max_redemptions_per_email: {
            title: 'Max redemptions per email',
            type: 'integer',
            minimum: 1
        },
        guest_allowed: {
            title: 'Guest allowed',
            type: 'boolean'
        },
        card_pack_id_quantity_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/MarketingCampaignCardPacksCreate'
            },
            minItems: 1
        }
    }
} as const;

export const $MarketingCampaignCardPackCreate = {
    required: ['card_pack_id', 'quantity'],
    type: 'object',
    properties: {
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $CardCreateView = {
    required: ['card_set_id'],
    type: 'object',
    properties: {
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoView'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $CardAttributeResponse = {
    required: ['id', 'workspace_type', 'workspace_id', 'count'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        card_variant_attribute: {
            '$ref': '#/definitions/CardVariantAttributeResponse'
        },
        count: {
            title: 'Count',
            type: 'integer'
        }
    }
} as const;

export const $CardAttributeCreate = {
    required: ['card_variant_attribute'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        }
    }
} as const;

export const $CardAttributeDecrease = {
    required: ['card_variant_attribute', 'count'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $CardAttributeIncrease = {
    required: ['card_variant_attribute', 'count'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $CardDesignResponse = {
    required: ['id', 'workspace_type', 'workspace_id', 'card_set_id', 'card_set_name', 'count'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template_variant_base: {
            '$ref': '#/definitions/CardDesignSetTemplateVariantBaseResponse'
        },
        count: {
            title: 'Count',
            type: 'integer'
        }
    }
} as const;

export const $CardDesignCreate = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        }
    }
} as const;

export const $CardDesignDecrease = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base', 'count'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $CardDesignIncrease = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base', 'count'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $CardFullCreateView = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base', 'card_variant_attributes'],
    type: 'object',
    properties: {
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoView'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsView'
        }
    }
} as const;

export const $CardInternalCreateView = {
    required: ['card_set_template', 'card_variant_base', 'card_variant_attributes'],
    type: 'object',
    properties: {
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoView'
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsView'
        }
    }
} as const;

export const $WorkspaceCardSetResponse = {
    required: ['id', 'name', 'priority', 'active', 'card_set_metadata', 'card_set_template_variant_bases', 'card_variant_attributes'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        card_set_metadata: {
            title: 'Card set metadata',
            type: 'object'
        },
        card_set_template_variant_bases: {
            type: 'array',
            items: {
                '$ref': '#/definitions/WorkspaceCardSetTemplateVariantBaseResponse'
            }
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                '$ref': '#/definitions/WorkspaceCardSetVariantAttributeResponse'
            }
        }
    }
} as const;

export const $SwaggerCardView = {
    required: ['id', 'created', 'active', 'workspace_type', 'workspace_id', 'card_processing_status', 'card_set_id', 'card_set_name', 'card_set_template', 'card_variant_base', 'card_variant_attributes', 'card_creation_step_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoResponseSerializers'
        },
        card_processing_status: {
            title: 'Card processing status',
            type: 'string',
            enum: ['not_started', 'submitted', 'generating', 'completed', 'finalized', 'failed', 'deleted', 'variant_locked', 'variant_submitted', 'variant_generating']
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsResponse'
        },
        card_preview: {
            '$ref': '#/definitions/CardPreviewView'
        },
        card_creation_step_status: {
            '$ref': '#/definitions/CardCreationStep'
        }
    }
} as const;

export const $CardFinalizeView = {
    type: 'object',
    properties: {}
} as const;

export const $CardUpdateView = {
    type: 'object',
    properties: {
        athlete_info: {
            '$ref': '#/definitions/AthleteInfoView'
        },
        card_build_options: {
            '$ref': '#/definitions/CardBuildOptionsView'
        }
    }
} as const;

export const $CardVariantCreateView = {
    required: ['card_set_template', 'card_variant_base', 'card_variant_attributes'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        }
    }
} as const;

export const $MarketingCampaignClaimRequest = {
    required: ['campaign_name'],
    type: 'object',
    properties: {
        campaign_name: {
            title: 'Campaign name',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $MarketingCampaignClaimResponse = {
    required: ['unopened_card_pack_id', 'count'],
    type: 'object',
    properties: {
        unopened_card_pack_id: {
            title: 'Unopened card pack id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer'
        }
    }
} as const;

export const $UnopenedCardPackResponse = {
    required: ['id', 'workspace_type', 'workspace_id', 'count', 'card_pack'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer'
        },
        card_pack: {
            '$ref': '#/definitions/CardPackResponse'
        }
    }
} as const;

export const $UnopenedCardPackCreate = {
    required: ['card_pack_id', 'count'],
    type: 'object',
    properties: {
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $UnopenedCardPackCreateUpdateResponse = {
    required: ['id', 'workspace_type', 'workspace_id', 'count', 'card_pack_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer'
        },
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $UnopenedCardPackDecrease = {
    required: ['card_pack_id', 'count'],
    type: 'object',
    properties: {
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $UnopenedCardPackIncrease = {
    required: ['card_pack_id', 'count'],
    type: 'object',
    properties: {
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $OpenUnopenedCardPack = {
    required: ['count'],
    type: 'object',
    properties: {
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $OpenUnopenedCardPackResponse = {
    required: ['attributes_won_list', 'designs_won_list'],
    type: 'object',
    properties: {
        attributes_won_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OpenUnopenedCardPackAttributeResponse'
            }
        },
        designs_won_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OpenUnopenedCardPackDesignResponse'
            }
        }
    }
} as const;

export const $AthleteInfoResponseSerializers = {
    required: ['position', 'team_name', 'full_name', 'first_name', 'last_name', 'age', 'city', 'state', 'primary_sport', 'season_description', 'other_sports', 'hobby'],
    type: 'object',
    properties: {
        position: {
            title: 'Position',
            type: 'string',
            minLength: 1
        },
        team_name: {
            title: 'Team name',
            type: 'string',
            minLength: 1
        },
        full_name: {
            title: 'Full name',
            type: 'string',
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            minLength: 1
        },
        player_number: {
            title: 'Player number',
            type: 'string',
            minLength: 1
        },
        player_position_acronym: {
            title: 'Player position acronym',
            type: 'string',
            minLength: 1
        },
        age: {
            title: 'Age',
            type: 'string',
            minLength: 1
        },
        city: {
            title: 'City',
            type: 'string',
            minLength: 1
        },
        state: {
            title: 'State',
            type: 'string',
            minLength: 1
        },
        blurb: {
            title: 'Blurb',
            type: 'string',
            minLength: 1
        },
        medium_blurb: {
            title: 'Medium blurb',
            type: 'string',
            minLength: 1
        },
        short_blurb: {
            title: 'Short blurb',
            type: 'string',
            minLength: 1
        },
        primary_sport: {
            title: 'Primary sport',
            type: 'string',
            minLength: 1
        },
        season_description: {
            title: 'Season description',
            type: 'string',
            minLength: 1
        },
        nickname: {
            title: 'Nickname',
            type: 'string',
            minLength: 1
        },
        other_sports: {
            title: 'Other sports',
            type: 'string',
            minLength: 1
        },
        hobby: {
            title: 'Hobby',
            type: 'string',
            minLength: 1
        },
        photo_action_hint: {
            title: 'Photo action hint',
            type: 'string',
            minLength: 1
        },
        skin_tone_selected: {
            title: 'Skin tone selected',
            type: 'string',
            minLength: 1
        },
        race_selected: {
            title: 'Race selected',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardBuildOptionsResponse = {
    type: 'object',
    properties: {
        zoom: {
            title: 'Zoom',
            type: 'string',
            format: 'decimal'
        },
        x_mov: {
            title: 'X mov',
            type: 'integer',
            maximum: 10000,
            minimum: -10000
        },
        y_mov: {
            title: 'Y mov',
            type: 'integer',
            maximum: 10000,
            minimum: -10000
        },
        card_build_front: {
            title: 'Card build front',
            type: 'string',
            enum: ['vertical']
        },
        card_build_back: {
            title: 'Card build back',
            type: 'string',
            enum: ['simple', 'blurb', 'stats']
        },
        framing_assist: {
            title: 'Framing assist',
            type: 'boolean'
        }
    }
} as const;

export const $CardPreviewView = {
    required: ['card_front_preview_uri', 'card_back_preview_uri'],
    type: 'object',
    properties: {
        card_front_preview_uri: {
            title: 'Card front preview uri',
            type: 'string',
            minLength: 1
        },
        card_back_preview_uri: {
            title: 'Card back preview uri',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardPackCardSetSetTemplateVariantBaseResponse = {
    required: ['name', 'card_set_template', 'card_variant_base', 'card_set_name', 'card_set_id', 'card_set_set_template_variant_base_probability', 'card_set_set_template_variant_base_metadata', 'active'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_set_template_variant_base_probability: {
            title: 'Card set set template variant base probability',
            type: 'string',
            format: 'decimal'
        },
        card_set_set_template_variant_base_metadata: {
            title: 'Card set set template variant base metadata',
            type: 'object'
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $CardPackVariantAttributeResponse = {
    required: ['card_pack_variant_attribute', 'card_pack_variant_attribute_probability', 'card_pack_variant_attribute_metadata', 'active'],
    type: 'object',
    properties: {
        card_pack_variant_attribute: {
            title: 'Card pack variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_pack_variant_attribute_icon_url: {
            title: 'Card pack variant attribute icon url',
            type: 'string',
            minLength: 1
        },
        card_pack_variant_attribute_probability: {
            title: 'Card pack variant attribute probability',
            type: 'string',
            format: 'decimal'
        },
        card_pack_variant_attribute_metadata: {
            title: 'Card pack variant attribute metadata',
            type: 'object'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $CardPackVariantAttributeCreate = {
    required: ['card_pack_variant_attribute', 'card_pack_variant_attribute_probability', 'card_pack_variant_attribute_metadata'],
    type: 'object',
    properties: {
        card_pack_variant_attribute: {
            title: 'Card pack variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_pack_variant_attribute_icon_file_tag: {
            title: 'Card pack variant attribute icon file tag',
            type: 'string',
            minLength: 1
        },
        card_pack_variant_attribute_probability: {
            title: 'Card pack variant attribute probability',
            type: 'string',
            format: 'decimal'
        },
        card_pack_variant_attribute_metadata: {
            title: 'Card pack variant attribute metadata',
            type: 'object'
        }
    }
} as const;

export const $CardPackCardSetSetTemplateVariantBaseCreate = {
    required: ['card_set_template', 'card_variant_base', 'card_set_id', 'card_set_set_template_variant_base_count_number', 'card_set_set_template_variant_base_metadata'],
    type: 'object',
    properties: {
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_set_template_variant_base_count_number: {
            title: 'Card set set template variant base count number',
            type: 'integer',
            minimum: 1
        },
        card_set_set_template_variant_base_metadata: {
            title: 'Card set set template variant base metadata',
            type: 'object'
        }
    }
} as const;

export const $CardSetTemplateVariantBaseResponse = {
    required: ['name', 'card_set_template', 'card_variant_base', 'card_set_template_variant_base_metadata', 'active', 'default', 'priority'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_template_variant_base_metadata: {
            title: 'Card set template variant base metadata',
            type: 'object'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        }
    }
} as const;

export const $CardSetVariantAttributeResponse = {
    required: ['card_variant_attribute', 'card_set_variant_attribute_metadata', 'default', 'active', 'priority'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_variant_attribute_metadata: {
            title: 'Card set variant attribute metadata',
            type: 'object'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        }
    }
} as const;

export const $CardSetVariantAttributeCreate = {
    required: ['card_variant_attribute', 'card_set_variant_attribute_metadata', 'default', 'priority'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_sample_front_file_tag: {
            title: 'Card sample front file tag',
            type: 'string',
            minLength: 1
        },
        card_sample_back_file_tag: {
            title: 'Card sample back file tag',
            type: 'string',
            minLength: 1
        },
        card_icon_file_tag: {
            title: 'Card icon file tag',
            type: 'string',
            minLength: 1
        },
        card_set_variant_attribute_metadata: {
            title: 'Card set variant attribute metadata',
            type: 'object'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        }
    }
} as const;

export const $CardSetTemplateVariantBaseCreate = {
    required: ['name', 'card_set_template', 'card_variant_base', 'card_set_template_variant_base_metadata', 'default', 'priority'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 20,
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_sample_front_file_tag: {
            title: 'Card sample front file tag',
            type: 'string',
            minLength: 1
        },
        card_sample_back_file_tag: {
            title: 'Card sample back file tag',
            type: 'string',
            minLength: 1
        },
        card_icon_file_tag: {
            title: 'Card icon file tag',
            type: 'string',
            minLength: 1
        },
        card_set_template_variant_base_metadata: {
            title: 'Card set template variant base metadata',
            type: 'object'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        }
    }
} as const;

export const $ServiceCardsDownloadCardView = {
    required: ['id', 'workspace_type', 'workspace_id', 'card_processing_status', 'card_set_id', 'card_set_name', 'card_set_template', 'card_variant_base', 'card_variant_attributes', 'athlete_info'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        card_download_info: {
            '$ref': '#/definitions/CardDownloadView'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        card_processing_status: {
            title: 'Card processing status',
            type: 'string',
            enum: ['not_started', 'submitted', 'generating', 'completed', 'finalized', 'failed', 'deleted', 'variant_locked', 'variant_submitted', 'variant_generating']
        },
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_variant_attributes: {
            type: 'array',
            items: {
                type: 'string',
                enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
            }
        },
        athlete_info: {
            '$ref': '#/definitions/ServiceCardSummaryAthleteInfoView'
        }
    }
} as const;

export const $ServiceCardsDownloadCardErrorView = {
    required: ['card_id', 'error'],
    type: 'object',
    properties: {
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        error: {
            title: 'Error',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardUploadAthleteInfoView = {
    type: 'object',
    properties: {
        age: {
            title: 'Age',
            type: 'string'
        },
        blurb: {
            title: 'Blurb',
            type: 'string'
        },
        blurb_costs: {
            title: 'Blurb costs',
            type: 'object'
        },
        city: {
            title: 'City',
            type: 'string'
        },
        first_name: {
            title: 'First name',
            type: 'string'
        },
        full_name: {
            title: 'Full name',
            type: 'string'
        },
        hobby: {
            title: 'Hobby',
            type: 'string'
        },
        last_name: {
            title: 'Last name',
            type: 'string'
        },
        nickname: {
            title: 'Nickname',
            type: 'string'
        },
        other_sports: {
            title: 'Other sports',
            type: 'string'
        },
        player_number: {
            title: 'Player number',
            type: 'string'
        },
        player_position_acronym: {
            title: 'Player position acronym',
            type: 'string'
        },
        position: {
            title: 'Position',
            type: 'string'
        },
        primary_sport: {
            title: 'Primary sport',
            type: 'string'
        },
        season_description: {
            title: 'Season description',
            type: 'string'
        },
        short_blurb: {
            title: 'Short blurb',
            type: 'string'
        },
        short_blurb_costs: {
            title: 'Short blurb costs',
            type: 'object'
        },
        state: {
            title: 'State',
            type: 'string'
        },
        team_name: {
            title: 'Team name',
            type: 'string'
        },
        medium_blurb: {
            title: 'Medium blurb',
            type: 'string'
        },
        mebium_blurb_costs: {
            title: 'Mebium blurb costs',
            type: 'object'
        },
        photo_action_hint: {
            title: 'Photo action hint',
            type: 'string'
        },
        not_photo_action: {
            title: 'Not photo action',
            type: 'string'
        },
        skin_tone_selected: {
            title: 'Skin tone selected',
            type: 'string'
        },
        race_selected: {
            title: 'Race selected',
            type: 'string'
        },
        image_transformation_useful: {
            title: 'Image transformation useful',
            type: 'boolean'
        },
        gender: {
            title: 'Gender',
            type: 'string'
        }
    }
} as const;

export const $MarketingCampaignCardPacksCreate = {
    required: ['card_pack_id', 'quantity'],
    type: 'object',
    properties: {
        card_pack_id: {
            title: 'Card pack id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $AthleteInfoView = {
    required: ['position', 'team_name', 'full_name', 'first_name', 'last_name', 'age', 'city', 'state', 'primary_sport', 'season_description', 'other_sports', 'hobby'],
    type: 'object',
    properties: {
        position: {
            title: 'Position',
            type: 'string',
            minLength: 1
        },
        team_name: {
            title: 'Team name',
            type: 'string',
            minLength: 1
        },
        full_name: {
            title: 'Full name',
            type: 'string',
            minLength: 1
        },
        first_name: {
            title: 'First name',
            type: 'string',
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            minLength: 1
        },
        player_number: {
            title: 'Player number',
            type: 'integer',
            maximum: 99,
            minimum: 0,
            'x-nullable': true
        },
        player_position_acronym: {
            title: 'Player position acronym',
            type: 'string',
            maxLength: 2,
            minLength: 1
        },
        age: {
            title: 'Age',
            type: 'integer'
        },
        city: {
            title: 'City',
            type: 'string',
            minLength: 1
        },
        state: {
            title: 'State',
            type: 'string',
            enum: ['AL', 'AK', 'AZ', 'AR', 'AS', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'TT', 'UT', 'VT', 'VA', 'VI', 'WA', 'WV', 'WI', 'WY']
        },
        blurb: {
            title: 'Blurb',
            type: 'string',
            'x-nullable': true
        },
        medium_blurb: {
            title: 'Medium blurb',
            type: 'string',
            'x-nullable': true
        },
        short_blurb: {
            title: 'Short blurb',
            type: 'string',
            'x-nullable': true
        },
        primary_sport: {
            title: 'Primary sport',
            type: 'string',
            minLength: 1
        },
        season_description: {
            title: 'Season description',
            type: 'string',
            minLength: 1
        },
        nickname: {
            title: 'Nickname',
            type: 'string',
            minLength: 1
        },
        other_sports: {
            title: 'Other sports',
            type: 'string',
            minLength: 1
        },
        hobby: {
            title: 'Hobby',
            type: 'string',
            minLength: 1
        },
        photo_action_hint: {
            title: 'Photo action hint',
            type: 'string',
            minLength: 1
        },
        skin_tone_selected: {
            title: 'Skin tone selected',
            type: 'string',
            enum: ['fair_light', 'medium_tan', 'dark_deep']
        },
        race_selected: {
            title: 'Race selected',
            type: 'string',
            minLength: 1
        },
        gender: {
            title: 'Gender',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardVariantAttributeResponse = {
    required: ['card_variant_attribute'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_variant_attribute_icon_file_url: {
            title: 'Card variant attribute icon file url',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardDesignSetTemplateVariantBaseResponse = {
    required: ['card_set_template', 'card_variant_base', 'card_set_template_variant_base_metadata'],
    type: 'object',
    properties: {
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_template_variant_base_metadata: {
            title: 'Card set template variant base metadata',
            type: 'object'
        }
    }
} as const;

export const $CardBuildOptionsView = {
    type: 'object',
    properties: {
        zoom: {
            title: 'Zoom',
            type: 'string',
            format: 'decimal'
        },
        x_mov: {
            title: 'X mov',
            type: 'integer',
            maximum: 10000,
            minimum: -10000
        },
        y_mov: {
            title: 'Y mov',
            type: 'integer',
            maximum: 10000,
            minimum: -10000
        },
        card_build_front: {
            title: 'Card build front',
            type: 'string',
            enum: ['vertical']
        },
        card_build_back: {
            title: 'Card build back',
            type: 'string',
            enum: ['simple', 'blurb', 'stats']
        },
        framing_assist: {
            title: 'Framing assist',
            type: 'boolean'
        }
    }
} as const;

export const $WorkspaceCardSetTemplateVariantBaseResponse = {
    required: ['name', 'card_set_template', 'card_variant_base', 'card_set_template_variant_base_metadata', 'active', 'default', 'priority', 'locked', 'count'],
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_template_variant_base_metadata: {
            title: 'Card set template variant base metadata',
            type: 'object'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        locked: {
            title: 'Locked',
            type: 'boolean'
        },
        count: {
            title: 'Count',
            type: 'integer'
        }
    }
} as const;

export const $WorkspaceCardSetVariantAttributeResponse = {
    required: ['card_variant_attribute', 'card_set_variant_attribute_metadata', 'default', 'active', 'priority', 'locked', 'count'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_variant_attribute_metadata: {
            title: 'Card set variant attribute metadata',
            type: 'object'
        },
        default: {
            title: 'Default',
            type: 'boolean'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        priority: {
            title: 'Priority',
            type: 'integer'
        },
        locked: {
            title: 'Locked',
            type: 'boolean'
        },
        count: {
            title: 'Count',
            type: 'integer'
        }
    }
} as const;

export const $CardCreationStep = {
    required: ['card_create_step_timestamp_list', 'card_create_step_current_name', 'card_create_step_current', 'card_create_step_count'],
    type: 'object',
    properties: {
        card_create_step_timestamp_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardCreationStepTimestamp'
            }
        },
        card_create_step_current_name: {
            title: 'Card create step current name',
            type: 'string',
            enum: ['blurb_generation', 'image_normalization', 'image_transformation', 'background_removal', 'user_photo_preparation', 'card_build', 'completed']
        },
        card_create_step_current: {
            title: 'Card create step current',
            type: 'integer'
        },
        card_create_step_count: {
            title: 'Card create step count',
            type: 'integer'
        }
    }
} as const;

export const $OpenUnopenedCardPackAttributeResponse = {
    required: ['card_variant_attribute', 'count', 'card_variant_attribute_metadata'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            enum: ['laser_eyes', 'anime', 'ninja', 'roblox', 'popout', 'mirage']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        },
        card_variant_attribute_icon_url: {
            title: 'Card variant attribute icon url',
            type: 'string',
            minLength: 1
        },
        card_variant_attribute_metadata: {
            title: 'Card variant attribute metadata',
            type: 'object'
        }
    }
} as const;

export const $OpenUnopenedCardPackDesignResponse = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base', 'count', 'card_set_set_template_variant_base_metadata', 'card_set_name'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            enum: ['season0', 'season0fb', 'galaxy-constellation', 'galaxy-starburst', 'galaxy-nebula']
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            enum: ['blue', 'pink-green', 'orange-purple', 'gold', 'teal', 'red-yellow', 'green-white']
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_set_template_variant_base_metadata: {
            title: 'Card set set template variant base metadata',
            type: 'object'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardDownloadView = {
    required: ['card_files_uri'],
    type: 'object',
    properties: {
        card_files_uri: {
            title: 'Card files uri',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $ServiceCardSummaryAthleteInfoView = {
    required: ['full_name'],
    type: 'object',
    properties: {
        full_name: {
            title: 'Full name',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardCreationStepTimestamp = {
    required: ['step', 'start_time'],
    type: 'object',
    properties: {
        step: {
            title: 'Step',
            type: 'string',
            enum: ['blurb_generation', 'image_normalization', 'image_transformation', 'background_removal', 'user_photo_preparation', 'card_build', 'completed']
        },
        start_time: {
            title: 'Start time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        }
    }
} as const;

export const $AbandonedCartReminderRequest = {
    required: ['abandoned_cart_reminder_id'],
    type: 'object',
    properties: {
        abandoned_cart_reminder_id: {
            title: 'Abandoned cart reminder id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $DiscountCouponView = {
    required: ['id', 'active', 'created', 'code', 'discount_coupon_type', 'discount_coupon_data', 'begin_time', 'end_time'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        code: {
            title: 'Code',
            type: 'string',
            minLength: 1
        },
        discount_coupon_type: {
            title: 'Discount coupon type',
            type: 'string',
            enum: ['threshold_percent', 'threshold_direct', 'threshold_free_shipping', 'buy_x_cards_get_y_cards_free']
        },
        discount_coupon_data: {
            title: 'Discount coupon data',
            type: 'object'
        },
        begin_time: {
            title: 'Begin time',
            type: 'string',
            format: 'date-time'
        },
        end_time: {
            title: 'End time',
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $DiscountCouponCreate = {
    required: ['code', 'discount_coupon_type', 'discount_coupon_data', 'begin_time', 'end_time'],
    type: 'object',
    properties: {
        code: {
            title: 'Code',
            type: 'string',
            minLength: 1
        },
        discount_coupon_type: {
            title: 'Discount coupon type',
            type: 'string',
            enum: ['threshold_percent', 'threshold_direct', 'threshold_free_shipping', 'buy_x_cards_get_y_cards_free']
        },
        discount_coupon_data: {
            title: 'Discount coupon data',
            type: 'object'
        },
        begin_time: {
            title: 'Begin time',
            type: 'string',
            format: 'date-time'
        },
        end_time: {
            title: 'End time',
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $FreeCardCouponView = {
    required: ['id', 'active', 'created', 'code', 'free_cards_to_give', 'claimed', 'claimed_by_user_id', 'claimed_for_workspace_id', 'claimed_time'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        code: {
            title: 'Code',
            type: 'string',
            minLength: 1
        },
        free_cards_to_give: {
            title: 'Free cards to give',
            type: 'integer'
        },
        claimed: {
            title: 'Claimed',
            type: 'boolean'
        },
        claimed_by_user_id: {
            title: 'Claimed by user id',
            type: 'string',
            format: 'uuid'
        },
        claimed_for_workspace_id: {
            title: 'Claimed for workspace id',
            type: 'string',
            format: 'uuid'
        },
        claimed_time: {
            title: 'Claimed time',
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $FreeCardCouponCreate = {
    required: ['number_coupons', 'free_cards_per_coupon'],
    type: 'object',
    properties: {
        number_coupons: {
            title: 'Number coupons',
            type: 'integer',
            minimum: 1
        },
        free_cards_per_coupon: {
            title: 'Free cards per coupon',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $OrderInternalView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'free_card_reserved_count', 'discount_code', 'discount_coupon_amount', 'billing_address', 'shipping_address', 'order_logs', 'order_items', 'order_by_user_id', 'communications_metadata', 'marketing_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        free_card_reserved_count: {
            title: 'Free card reserved count',
            type: 'integer'
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        billing_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        shipping_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        order_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderLog'
            }
        },
        order_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderItemExtendedView'
            }
        },
        order_by_user_id: {
            title: 'Order by user id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        communications_metadata: {
            title: 'Communications metadata',
            type: 'object'
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $OrderInternalPrintingStartedBulkRequest = {
    required: ['order_id_list'],
    type: 'object',
    properties: {
        order_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $OrderInternalOpView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'free_card_reserved_count', 'discount_code', 'discount_coupon_amount'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        free_card_reserved_count: {
            title: 'Free card reserved count',
            type: 'integer'
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        }
    }
} as const;

export const $ProductPriceView = {
    required: ['id', 'created', 'product_type', 'product_id', 'price', 'quantity_price_array', 'active'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        quantity_price_array: {
            type: 'array',
            items: {
                '$ref': '#/definitions/QuantityPrice'
            }
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $ProductPriceCreate = {
    required: ['product_type', 'product_id', 'price', 'quantity_price_array'],
    type: 'object',
    properties: {
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        quantity_price_array: {
            type: 'array',
            items: {
                '$ref': '#/definitions/QuantityPrice'
            }
        }
    }
} as const;

export const $ProductPriceUpdate = {
    type: 'object',
    properties: {
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        quantity_price_array: {
            type: 'array',
            items: {
                '$ref': '#/definitions/QuantityPrice'
            }
        }
    }
} as const;

export const $OrderServiceView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'billing_address', 'shipping_address', 'order_logs', 'order_by_user_id', 'communications_metadata', 'marketing_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        billing_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        shipping_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        order_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderLog'
            }
        },
        order_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderItemServiceView'
            }
        },
        order_by_user_id: {
            title: 'Order by user id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        communications_metadata: {
            title: 'Communications metadata',
            type: 'object'
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $WorkspaceOrderStatisticsRequest = {
    required: ['workspace_id_list'],
    type: 'object',
    properties: {
        workspace_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $WorkspaceOrderStatisticsResponse = {
    required: ['workspace_id', 'not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped'],
    type: 'object',
    properties: {
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        not_started: {
            title: 'Not started',
            type: 'integer'
        },
        payment_started: {
            title: 'Payment started',
            type: 'integer'
        },
        payment_failed: {
            title: 'Payment failed',
            type: 'integer'
        },
        checkout_completed: {
            title: 'Checkout completed',
            type: 'integer'
        },
        checkout_canceled: {
            title: 'Checkout canceled',
            type: 'integer'
        },
        checkout_timeout: {
            title: 'Checkout timeout',
            type: 'integer'
        },
        payment_not_needed: {
            title: 'Payment not needed',
            type: 'integer'
        },
        in_process: {
            title: 'In process',
            type: 'integer'
        },
        shipped: {
            title: 'Shipped',
            type: 'integer'
        }
    }
} as const;

export const $OrderOpView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'free_card_reserved_count', 'discount_code', 'discount_coupon_amount'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        free_card_reserved_count: {
            title: 'Free card reserved count',
            type: 'integer'
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        }
    }
} as const;

export const $OrderView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'free_card_reserved_count', 'discount_code', 'discount_coupon_amount', 'billing_address', 'shipping_address', 'order_logs', 'order_items'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        free_card_reserved_count: {
            title: 'Free card reserved count',
            type: 'integer'
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        billing_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        shipping_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        order_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderLog'
            }
        },
        order_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderItemExtendedView'
            }
        }
    }
} as const;

export const $RetryProcessStripeEventRequest = {
    required: ['stripe_event_id'],
    type: 'object',
    properties: {
        stripe_event_id: {
            title: 'Stripe event id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $CartFullView = {
    required: ['valid', 'cart_items', 'total_discount', 'subtotal_price', 'free_card_discount', 'free_card_used_count', 'shipping_cost', 'shipping_discount', 'total_price', 'discount_coupon_amount'],
    type: 'object',
    properties: {
        valid: {
            title: 'Valid',
            type: 'boolean'
        },
        cart_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CartItemExtendedView'
            }
        },
        total_discount: {
            title: 'Total discount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        free_card_discount: {
            title: 'Free card discount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        free_card_used_count: {
            title: 'Free card used count',
            type: 'integer',
            'x-nullable': true
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        shipping_discount: {
            title: 'Shipping discount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        total_price: {
            title: 'Total price',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        }
    }
} as const;

export const $CartItemView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'product_type', 'product_id', 'quantity'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        }
    }
} as const;

export const $CartItemCardCreate = {
    required: ['card_id', 'quantity'],
    type: 'object',
    properties: {
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            maximum: 999,
            minimum: 1
        }
    }
} as const;

export const $CartItemTeamCardCreate = {
    required: ['team_id', 'team_card_id', 'quantity'],
    type: 'object',
    properties: {
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        team_card_id: {
            title: 'Team card id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            maximum: 999,
            minimum: 1
        }
    }
} as const;

export const $CartItemTeamPackCreate = {
    required: ['team_id', 'quantity'],
    type: 'object',
    properties: {
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            maximum: 999,
            minimum: 1
        }
    }
} as const;

export const $CartItemUpdate = {
    required: ['quantity'],
    type: 'object',
    properties: {
        quantity: {
            title: 'Quantity',
            type: 'integer',
            maximum: 999,
            minimum: 1
        }
    }
} as const;

export const $CheckoutStartRequest = {
    type: 'object',
    properties: {
        free_cards_to_use: {
            title: 'Free cards to use',
            type: 'integer',
            minimum: 1
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $SwaggerCheckoutStartResponse = {
    required: ['order', 'payment_type', 'payment_processing_data'],
    type: 'object',
    properties: {
        order: {
            '$ref': '#/definitions/OrderOpView'
        },
        payment_type: {
            title: 'Payment type',
            type: 'string',
            enum: ['stripe', 'not_needed']
        },
        payment_processing_data: {
            '$ref': '#/definitions/StripePaymentProcessingDataResponse'
        }
    }
} as const;

export const $WorkspaceFreeCardCountView = {
    required: ['id', 'workspace_type', 'workspace_id', 'acquired_count', 'reserved_count', 'used_count'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        acquired_count: {
            title: 'Acquired count',
            type: 'integer'
        },
        reserved_count: {
            title: 'Reserved count',
            type: 'integer'
        },
        used_count: {
            title: 'Used count',
            type: 'integer'
        },
        available_count: {
            title: 'Available count',
            type: 'string',
            readOnly: true
        }
    }
} as const;

export const $WorkspaceFreeCardCountDecrease = {
    required: ['count'],
    type: 'object',
    properties: {
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $WorkspaceFreeCardCountIncrease = {
    required: ['count'],
    type: 'object',
    properties: {
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $FreeCardCouponClaimResponse = {
    required: ['id', 'workspace_type', 'workspace_id', 'acquired_count', 'reserved_count', 'used_count'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        acquired_count: {
            title: 'Acquired count',
            type: 'integer'
        },
        reserved_count: {
            title: 'Reserved count',
            type: 'integer'
        },
        used_count: {
            title: 'Used count',
            type: 'integer'
        },
        available_count: {
            title: 'Available count',
            type: 'string',
            readOnly: true
        }
    }
} as const;

export const $OrderRewardResponse = {
    required: ['attributes_won_list', 'designs_won_list'],
    type: 'object',
    properties: {
        attributes_won_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderRewardAttributeResponse'
            }
        },
        designs_won_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderRewardDesignResponse'
            }
        }
    }
} as const;

export const $OrderUpdateCardsRequest = {
    required: ['order_item_id_list', 'card_update_list'],
    type: 'object',
    properties: {
        order_item_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        card_update_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/CardUpdateRequest'
            }
        }
    }
} as const;

export const $OrderUpdateCardsResponse = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'free_card_reserved_count', 'discount_code', 'discount_coupon_amount', 'billing_address', 'shipping_address', 'order_logs', 'order_items'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        free_card_reserved_count: {
            title: 'Free card reserved count',
            type: 'integer'
        },
        discount_code: {
            title: 'Discount code',
            type: 'string',
            minLength: 1,
            'x-nullable': true
        },
        discount_coupon_amount: {
            title: 'Discount coupon amount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        billing_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        shipping_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        order_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderLog'
            }
        },
        order_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderItemExtendedView'
            }
        }
    }
} as const;

export const $OrderMarketingStatus = {
    required: ['order_id', 'marketing_status'],
    type: 'object',
    properties: {
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid'
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $OrderAddressView = {
    type: 'object',
    properties: {
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        city: {
            title: 'City',
            type: 'string',
            minLength: 1
        },
        country: {
            title: 'Country',
            type: 'string',
            enum: ['AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'CV', 'KH', 'CM', 'CA', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'SZ', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'KP', 'MK', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'KR', 'SS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'UM', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW']
        },
        line_1: {
            title: 'Line 1',
            type: 'string',
            minLength: 1
        },
        line_2: {
            title: 'Line 2',
            type: 'string'
        },
        postal_code: {
            title: 'Postal code',
            type: 'string',
            minLength: 1
        },
        state: {
            title: 'State',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $OrderLog = {
    required: ['old_status', 'new_status', 'text', 'user_id'],
    type: 'object',
    properties: {
        old_status: {
            title: 'Old status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        new_status: {
            title: 'New status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        text: {
            title: 'Text',
            type: 'string',
            maxLength: 2048,
            minLength: 1
        },
        timestamp: {
            title: 'Timestamp',
            type: 'string',
            format: 'date-time',
            default: '2025-02-04T16:12:06.915559Z'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            maxLength: 42,
            minLength: 1
        }
    }
} as const;

export const $OrderItemServiceView = {
    required: ['id', 'product_type', 'product_id', 'quantity', 'full_item_price', 'item_price', 'price', 'quantity_discount'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        full_item_price: {
            title: 'Full item price',
            type: 'string',
            format: 'decimal'
        },
        item_price: {
            title: 'Item price',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        quantity_discount: {
            title: 'Quantity discount',
            type: 'string',
            format: 'decimal'
        }
    }
} as const;

export const $AccountOpsMarketingOrderView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'order_status', 'order_update_expiration_time', 'order_rewards_claimed', 'subtotal_price', 'shipping_cost', 'price', 'discount', 'billing_address', 'shipping_address', 'order_logs', 'order_by_user_id', 'communications_metadata', 'marketing_status'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_status: {
            title: 'Order status',
            type: 'string',
            enum: ['not_started', 'payment_started', 'payment_failed', 'checkout_completed', 'checkout_canceled', 'checkout_timeout', 'payment_not_needed', 'in_process', 'shipped']
        },
        order_update_expiration_time: {
            title: 'Order update expiration time',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        order_rewards_claimed: {
            title: 'Order rewards claimed',
            type: 'boolean'
        },
        subtotal_price: {
            title: 'Subtotal price',
            type: 'string',
            format: 'decimal'
        },
        shipping_cost: {
            title: 'Shipping cost',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        discount: {
            title: 'Discount',
            type: 'string',
            format: 'decimal'
        },
        billing_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        shipping_address: {
            '$ref': '#/definitions/OrderAddressView'
        },
        order_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderLog'
            }
        },
        order_items: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderItemServiceView'
            }
        },
        order_by_user_id: {
            title: 'Order by user id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        communications_metadata: {
            title: 'Communications metadata',
            type: 'object'
        },
        marketing_status: {
            title: 'Marketing status',
            type: 'string',
            enum: ['not_run', 'update_needed', 'completed', 'unprocessable']
        }
    }
} as const;

export const $OrderItemExtendedView = {
    required: ['id', 'product_type', 'product_id', 'product_description_type', 'product_description', 'quantity', 'full_item_price', 'item_price', 'price', 'quantity_discount'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1
        },
        product_description_type: {
            title: 'Product description type',
            type: 'string',
            enum: ['card_error', 'card', 'team_pack', 'item']
        },
        product_description: {
            title: 'Product description',
            type: 'object'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        full_item_price: {
            title: 'Full item price',
            type: 'string',
            format: 'decimal'
        },
        item_price: {
            title: 'Item price',
            type: 'string',
            format: 'decimal'
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        },
        quantity_discount: {
            title: 'Quantity discount',
            type: 'string',
            format: 'decimal'
        }
    }
} as const;

export const $QuantityPrice = {
    required: ['quantity_min', 'quantity_max', 'price'],
    type: 'object',
    properties: {
        quantity_min: {
            title: 'Quantity min',
            type: 'integer',
            minimum: 1
        },
        quantity_max: {
            title: 'Quantity max',
            type: 'integer',
            minimum: 1
        },
        price: {
            title: 'Price',
            type: 'string',
            format: 'decimal'
        }
    }
} as const;

export const $CartItemExtendedView = {
    required: ['id', 'created', 'workspace_type', 'workspace_id', 'product_type', 'product_id', 'product_description_type', 'product_description', 'quantity', 'full_item_price', 'item_price', 'total_price', 'quantity_discount', 'valid'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        product_type: {
            title: 'Product type',
            type: 'string',
            enum: ['card', 'item', 'team_card', 'team_pack']
        },
        product_id: {
            title: 'Product id',
            type: 'string',
            minLength: 1
        },
        product_description_type: {
            title: 'Product description type',
            type: 'string',
            enum: ['card_error', 'card', 'team_pack', 'item']
        },
        product_description: {
            title: 'Product description',
            type: 'object'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer'
        },
        full_item_price: {
            title: 'Full item price',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        item_price: {
            title: 'Item price',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        total_price: {
            title: 'Total price',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        quantity_discount: {
            title: 'Quantity discount',
            type: 'string',
            format: 'decimal',
            'x-nullable': true
        },
        valid: {
            title: 'Valid',
            type: 'boolean'
        }
    }
} as const;

export const $StripePaymentProcessingDataResponse = {
    required: ['client_secret'],
    type: 'object',
    properties: {
        client_secret: {
            title: 'Client secret',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $OrderRewardAttributeResponse = {
    required: ['card_variant_attribute', 'count', 'card_variant_attribute_metadata'],
    type: 'object',
    properties: {
        card_variant_attribute: {
            title: 'Card variant attribute',
            type: 'string',
            minLength: 1
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        },
        card_variant_attribute_icon_url: {
            title: 'Card variant attribute icon url',
            type: 'string',
            minLength: 1
        },
        card_variant_attribute_metadata: {
            title: 'Card variant attribute metadata',
            type: 'object'
        }
    }
} as const;

export const $OrderRewardDesignResponse = {
    required: ['card_set_id', 'card_set_template', 'card_variant_base', 'count', 'card_set_set_template_variant_base_metadata', 'card_set_name'],
    type: 'object',
    properties: {
        card_set_id: {
            title: 'Card set id',
            type: 'string',
            format: 'uuid'
        },
        card_set_template: {
            title: 'Card set template',
            type: 'string',
            minLength: 1
        },
        card_variant_base: {
            title: 'Card variant base',
            type: 'string',
            minLength: 1
        },
        count: {
            title: 'Count',
            type: 'integer',
            minimum: 1
        },
        card_sample_front_url: {
            title: 'Card sample front url',
            type: 'string',
            minLength: 1
        },
        card_sample_back_url: {
            title: 'Card sample back url',
            type: 'string',
            minLength: 1
        },
        card_icon_url: {
            title: 'Card icon url',
            type: 'string',
            minLength: 1
        },
        card_set_set_template_variant_base_metadata: {
            title: 'Card set set template variant base metadata',
            type: 'object'
        },
        card_set_name: {
            title: 'Card set name',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $CardUpdateRequest = {
    required: ['card_id', 'quantity'],
    type: 'object',
    properties: {
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            maximum: 999,
            minimum: 1
        }
    }
} as const;

export const $PrintCardRequestView = {
    required: ['id', 'created', 'updated', 'active', 'workspace_type', 'workspace_id', 'order_id', 'reference_id', 'card_id', 'print_finalized_time', 'print_card_request_status', 'print_card_request_logs'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        updated: {
            title: 'Updated',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user'],
            'x-nullable': true
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        reference_id: {
            title: 'Reference id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        print_finalized_time: {
            title: 'Print finalized time',
            type: 'string',
            format: 'date-time'
        },
        print_card_request_status: {
            title: 'Print card request status',
            type: 'string',
            enum: ['not_started', 'complete']
        },
        print_card_request_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/PrintCardRequestLog'
            }
        }
    }
} as const;

export const $LocalPrintCardRequestComplete = {
    required: ['print_card_request_id_list'],
    type: 'object',
    properties: {
        print_card_request_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $OrderPrintRequestCreate = {
    required: ['order_id', 'print_finalized_time', 'print_card_request_list'],
    type: 'object',
    properties: {
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid'
        },
        print_finalized_time: {
            title: 'Print finalized time',
            type: 'string',
            format: 'date-time'
        },
        print_card_request_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderPrintCardRequestCreate'
            }
        }
    }
} as const;

export const $OrderPrintRequestUpdate = {
    required: ['delete_print_card_request_reference_id_list', 'order_id', 'print_finalized_time', 'print_card_request_list'],
    type: 'object',
    properties: {
        delete_print_card_request_reference_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        },
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid'
        },
        print_finalized_time: {
            title: 'Print finalized time',
            type: 'string',
            format: 'date-time'
        },
        print_card_request_list: {
            type: 'array',
            items: {
                '$ref': '#/definitions/OrderPrintCardRequestCreate'
            }
        }
    }
} as const;

export const $PrintCardRequestCreate = {
    required: ['card_id', 'print_finalized_time'],
    type: 'object',
    properties: {
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid'
        },
        reference_id: {
            title: 'Reference id',
            type: 'string',
            format: 'uuid'
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        print_finalized_time: {
            title: 'Print finalized time',
            type: 'string',
            format: 'date-time'
        }
    }
} as const;

export const $PrintCardRequestUpdate = {
    type: 'object',
    properties: {
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user'],
            'x-nullable': true
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        order_id: {
            title: 'Order id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        reference_id: {
            title: 'Reference id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        print_finalized_time: {
            title: 'Print finalized time',
            type: 'string',
            format: 'date-time'
        },
        print_card_request_status: {
            title: 'Print card request status',
            type: 'string',
            enum: ['not_started', 'complete']
        },
        print_card_request_logs: {
            type: 'array',
            items: {
                '$ref': '#/definitions/PrintCardRequestLog'
            }
        }
    }
} as const;

export const $PrintCardRequestLog = {
    required: ['old_status', 'new_status', 'text', 'user_id'],
    type: 'object',
    properties: {
        old_status: {
            title: 'Old status',
            type: 'string',
            enum: ['not_started', 'complete'],
            'x-nullable': true
        },
        new_status: {
            title: 'New status',
            type: 'string',
            enum: ['not_started', 'complete']
        },
        text: {
            title: 'Text',
            type: 'string',
            maxLength: 2048,
            minLength: 1
        },
        timestamp: {
            title: 'Timestamp',
            type: 'string',
            format: 'date-time',
            default: '2025-03-07T15:38:06.965352Z'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            maxLength: 42,
            minLength: 1
        }
    }
} as const;

export const $OrderPrintCardRequestCreate = {
    required: ['workspace_type', 'workspace_id', 'reference_id', 'card_id', 'quantity'],
    type: 'object',
    properties: {
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        reference_id: {
            title: 'Reference id',
            type: 'string',
            format: 'uuid'
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        quantity: {
            title: 'Quantity',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $DataRetentionRunClearRequest = {
    required: ['page', 'page_size', 'user_type'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        },
        user_type: {
            title: 'User type',
            type: 'string',
            enum: ['client', 'guest']
        }
    }
} as const;

export const $DataRetentionRunCompleteRequest = {
    required: ['page', 'page_size'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $GuestUserLogin = {
    required: ['username', 'password', 'access_token'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserLoginWorkspaceNeededResponse = {
    required: ['type', 'id', 'name', 'workspace_id'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['organization', 'user']
        },
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $GuestUserMFALoginComplete = {
    required: ['code_id', 'code', 'password', 'access_token', 'refresh_token'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        },
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFALoginCompleteResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFALoginWorkspaceNeededResponse = {
    required: ['type', 'id', 'name', 'workspace_id'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['organization', 'user']
        },
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            minLength: 1
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $GuestUserMFALoginSendCode = {
    required: ['method'],
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        }
    }
} as const;

export const $GuestUserMFALoginSendCodeResponse = {
    required: ['code_id'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $GuestUserMFALoginStart = {
    required: ['username', 'password'],
    type: 'object',
    properties: {
        username: {
            title: 'Username',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFALoginStartResponse = {
    required: ['login_token'],
    type: 'object',
    properties: {
        login_token: {
            title: 'Login token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFALoginResend = {
    required: ['method'],
    type: 'object',
    properties: {
        method: {
            title: 'Method',
            type: 'string',
            enum: ['text', 'email']
        }
    }
} as const;

export const $GuestUserWorkspaceLoginResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFAWorkspaceLoginComplete = {
    required: ['code_id', 'code', 'password', 'access_token', 'refresh_token'],
    type: 'object',
    properties: {
        code_id: {
            title: 'Code id',
            type: 'string',
            format: 'uuid'
        },
        code: {
            title: 'Code',
            type: 'string',
            maxLength: 8,
            minLength: 1
        },
        password: {
            title: 'Password',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $GuestUserMFAWorkspaceLoginCompleteResponse = {
    required: ['access_token', 'refresh_token'],
    type: 'object',
    properties: {
        access_token: {
            title: 'Access token',
            type: 'string',
            minLength: 1
        },
        refresh_token: {
            title: 'Refresh token',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $MarketingSyncRunRequest = {
    required: ['page', 'page_size'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $MarketingSyncRunCompleteRequest = {
    required: ['page', 'page_size'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $OrderMarketingSyncRunRequest = {
    required: ['page', 'page_size'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $OrderMarketingSyncRunCompleteRequest = {
    required: ['page', 'page_size'],
    type: 'object',
    properties: {
        page: {
            title: 'Page',
            type: 'integer',
            minimum: 1
        },
        page_size: {
            title: 'Page size',
            type: 'integer',
            minimum: 1
        }
    }
} as const;

export const $TeamInternalSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal', 'team', 'team_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $TeamSearchViewResponse = {
    required: ['type', 'location', 'highlight', 'summary'],
    type: 'object',
    properties: {
        type: {
            title: 'Type',
            type: 'string',
            enum: ['community', 'channel', 'message', 'topic', 'user', 'user_internal', 'organization', 'organization_internal', 'team', 'team_internal']
        },
        location: {
            title: 'Location',
            type: 'string',
            maxLength: 50,
            minLength: 1
        },
        highlight: {
            title: 'Highlight',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        summary: {
            title: 'Summary',
            type: 'object',
            additionalProperties: {
                type: 'string',
                'x-nullable': true
            }
        }
    }
} as const;

export const $TeamInviteAccept = {
    required: ['signature'],
    type: 'object',
    properties: {
        signature: {
            title: 'Signature',
            type: 'string',
            maxLength: 150,
            minLength: 1
        }
    }
} as const;

export const $TeamInviteView = {
    required: ['team', 'inviting_user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        team: {
            title: 'Team',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        inviting_user_id: {
            title: 'Inviting user id',
            type: 'string',
            format: 'uuid'
        },
        expiration: {
            title: 'Expiration',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        accepted: {
            title: 'Accepted',
            type: 'boolean'
        },
        accepted_data: {
            title: 'Accepted data',
            type: 'object'
        }
    }
} as const;

export const $MemberTeamView = {
    required: ['id', 'created', 'active', 'owner', 'name', 'brand_data', 'description', 'member_role'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 128,
            minLength: 1
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['owner', 'admin', 'member']
        }
    }
} as const;

export const $TeamCardListRequest = {
    required: ['team_id_list'],
    type: 'object',
    properties: {
        team_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $TeamCardRawView = {
    required: ['id', 'created', 'active', 'team_id', 'card_id', 'workspace_type', 'workspace_id', 'athlete_name', 'metadata'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_name: {
            title: 'Athlete name',
            type: 'string',
            minLength: 1
        },
        metadata: {
            title: 'Metadata',
            type: 'object'
        }
    }
} as const;

export const $TeamLinkTeamAccessRequestedTrySendEmail = {
    required: ['team_link_id'],
    type: 'object',
    properties: {
        team_link_id: {
            title: 'Team link id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TeamView = {
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        },
        num_members: {
            title: 'Num members',
            type: 'integer',
            readOnly: true,
            default: 0
        }
    }
} as const;

export const $TeamCreate = {
    required: ['owner_id', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        owner_id: {
            title: 'Owner id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        }
    }
} as const;

export const $TeamCreateResponse = {
    required: ['id', 'created', 'active', 'owner', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        }
    }
} as const;

export const $TeamLinkTeamAccessRequestCreate = {
    required: ['signature'],
    type: 'object',
    properties: {
        signature: {
            title: 'Signature',
            type: 'string',
            minLength: 1
        }
    }
} as const;

export const $TeamAccessRequestView = {
    required: ['id', 'active', 'created', 'team_id', 'user_id', 'approved', 'approved_by_user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        approved: {
            title: 'Approved',
            type: 'boolean',
            'x-nullable': true
        },
        approved_by_user_id: {
            title: 'Approved by user id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        }
    }
} as const;

export const $TeamMemberView = {
    required: ['team', 'user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        team: {
            title: 'Team',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['admin', 'member']
        },
        member_access_rights: {
            title: 'Member access rights',
            type: 'object'
        }
    }
} as const;

export const $TeamProfileRequest = {
    required: ['team_id_list'],
    type: 'object',
    properties: {
        team_id_list: {
            type: 'array',
            items: {
                type: 'string',
                format: 'uuid'
            }
        }
    }
} as const;

export const $TeamProfileResponse = {
    required: ['id', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        }
    }
} as const;

export const $TeamInviteCreate = {
    type: 'object',
    properties: {
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TeamInviteCreateResponse = {
    required: ['team', 'inviting_user_id'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time',
            readOnly: true
        },
        team: {
            title: 'Team',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        email: {
            title: 'Email',
            type: 'string',
            format: 'email',
            maxLength: 128,
            minLength: 1,
            'x-nullable': true
        },
        inviting_user_id: {
            title: 'Inviting user id',
            type: 'string',
            format: 'uuid'
        },
        expiration: {
            title: 'Expiration',
            type: 'string',
            format: 'date-time',
            'x-nullable': true
        },
        accepted: {
            title: 'Accepted',
            type: 'boolean'
        },
        accepted_data: {
            title: 'Accepted data',
            type: 'object'
        }
    }
} as const;

export const $TeamMemberPublicProfileView = {
    required: ['user_id', 'first_name', 'last_name', 'display_name', 'user_metadata', 'member_role', 'active'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        },
        active: {
            title: 'Active',
            type: 'boolean'
        }
    }
} as const;

export const $TeamMemberViewResponse = {
    required: ['id', 'active', 'created', 'user_metadata', 'member_role', 'member_access_rights', 'team_id', 'user_id', 'first_name', 'last_name', 'display_name'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        user_metadata: {
            title: 'User metadata',
            type: 'object'
        },
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 12,
            minLength: 1
        },
        member_access_rights: {
            title: 'Member access rights',
            type: 'object'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        first_name: {
            title: 'First name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            maxLength: 50,
            'x-nullable': true
        },
        display_name: {
            title: 'Display name',
            type: 'string',
            maxLength: 128,
            'x-nullable': true
        }
    }
} as const;

export const $TeamMemberChangeRole = {
    required: ['member_role'],
    type: 'object',
    properties: {
        member_role: {
            title: 'Member role',
            type: 'string',
            enum: ['admin', 'member']
        }
    }
} as const;

export const $TeamMemberRoleView = {
    required: ['member_role'],
    type: 'object',
    properties: {
        member_role: {
            title: 'Member role',
            type: 'string',
            maxLength: 50,
            minLength: 1
        }
    }
} as const;

export const $TeamSetOwner = {
    required: ['owner'],
    type: 'object',
    properties: {
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TeamSetParameterResponse = {
    required: ['id', 'created', 'active', 'owner', 'name', 'brand_data', 'description'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        owner: {
            title: 'Owner',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        name: {
            title: 'Name',
            type: 'string',
            maxLength: 256,
            minLength: 1,
            'x-nullable': true
        },
        brand_data: {
            title: 'Brand data',
            type: 'object'
        },
        description: {
            title: 'Description',
            type: 'object'
        }
    }
} as const;

export const $TeamAccessRequestWithUserDataView = {
    required: ['id', 'active', 'created', 'team_id', 'user_id', 'approved', 'approved_by_user_id', 'user_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        },
        approved: {
            title: 'Approved',
            type: 'boolean',
            'x-nullable': true
        },
        approved_by_user_id: {
            title: 'Approved by user id',
            type: 'string',
            format: 'uuid',
            'x-nullable': true
        },
        user_data: {
            '$ref': '#/definitions/TeamAccessRequestUserData'
        }
    }
} as const;

export const $TeamAccessRequestCreate = {
    required: ['user_id'],
    type: 'object',
    properties: {
        user_id: {
            title: 'User id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TeamLinkTeamAccessRequestedSendEmail = {
    required: ['team_link_id'],
    type: 'object',
    properties: {
        team_link_id: {
            title: 'Team link id',
            type: 'string',
            format: 'uuid'
        }
    }
} as const;

export const $TeamCardView = {
    required: ['id', 'created', 'active', 'team_id', 'card_id', 'workspace_type', 'workspace_id', 'athlete_name', 'metadata', 'card_summary_description_type', 'card_summary', 'valid'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_name: {
            title: 'Athlete name',
            type: 'string',
            minLength: 1
        },
        metadata: {
            title: 'Metadata',
            type: 'object'
        },
        card_summary_description_type: {
            title: 'Card summary description type',
            type: 'string',
            enum: ['card_error', 'card', 'none']
        },
        card_summary: {
            title: 'Card summary',
            type: 'object'
        },
        valid: {
            title: 'Valid',
            type: 'boolean'
        }
    }
} as const;

export const $TeamCardCreateRequest = {
    required: ['card_id', 'workspace_type', 'workspace_id', 'athlete_name'],
    type: 'object',
    properties: {
        card_id: {
            title: 'Card id',
            type: 'string',
            format: 'uuid'
        },
        workspace_type: {
            title: 'Workspace type',
            type: 'string',
            enum: ['organization', 'user']
        },
        workspace_id: {
            title: 'Workspace id',
            type: 'string',
            format: 'uuid'
        },
        athlete_name: {
            title: 'Athlete name',
            type: 'string',
            minLength: 1
        },
        metadata: {
            title: 'Metadata',
            type: 'object'
        }
    }
} as const;

export const $TeamLinkView = {
    required: ['id', 'active', 'created', 'team_id', 'create_user_id', 'link', 'expiration', 'link_data'],
    type: 'object',
    properties: {
        id: {
            title: 'Id',
            type: 'string',
            format: 'uuid'
        },
        active: {
            title: 'Active',
            type: 'boolean'
        },
        created: {
            title: 'Created',
            type: 'string',
            format: 'date-time'
        },
        team_id: {
            title: 'Team id',
            type: 'string',
            format: 'uuid'
        },
        create_user_id: {
            title: 'Create user id',
            type: 'string',
            format: 'uuid'
        },
        link: {
            title: 'Link',
            type: 'string',
            minLength: 1
        },
        expiration: {
            title: 'Expiration',
            type: 'string',
            format: 'date-time'
        },
        link_data: {
            title: 'Link data',
            type: 'object'
        }
    }
} as const;

export const $TeamAccessRequestUserData = {
    required: ['first_name', 'last_name', 'email', 'email_verified', 'phone_number', 'phone_verified'],
    type: 'object',
    properties: {
        first_name: {
            title: 'First name',
            type: 'string',
            minLength: 1
        },
        last_name: {
            title: 'Last name',
            type: 'string',
            minLength: 1
        },
        email: {
            title: 'Email',
            type: 'string',
            minLength: 1
        },
        email_verified: {
            title: 'Email verified',
            type: 'boolean'
        },
        phone_number: {
            title: 'Phone number',
            type: 'string',
            minLength: 1
        },
        phone_verified: {
            title: 'Phone verified',
            type: 'boolean'
        }
    }
} as const;